import styled from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "RelatedTipsstyle__Container",
  componentId: "sc-1p4kp34-0"
})(["", ""], {
  "marginBottom": "104px"
});